module.exports = __webpack_public_path__ + "static/media/app2.342a53c2.png";